<script lang="ts">
    import { _ } from "svelte-i18n"
    import { getMyOrder } from "../../api"
    import { formatPriceCurrency, langField } from "../../i18n"
    import MiniLoader from "../widgets/MiniLoader.svelte"
    import Index from "../SEO/Index.svelte"

    export let token: string
    export let id: string
</script>

<Index noIndex="{true}" title="{$_('my-orders.order-details')}" metaDescription="{$_('meta.description')}" />
<section class="section-type-1 section_padding checkout">
    <div class="container">
        <h1>{$_("my-orders.order-details")}</h1>
        {#await getMyOrder(token, id)}
            <MiniLoader />
        {:then order}
            {#if order}
                <p>
                    {@html $_("my-orders.order-intro-html")}
                </p>

                <button
                    on:click="{() => {
                        history.back()
                    }}"
                    style="margin-bottom:60px;"
                    class="btn btn-secondary">&laquo; {$_("my-orders.back-to-orders")}</button
                >

                <div class="order_details">
                    <section>
                        <div class="header">
                            <h3>
                                {$_("my-orders.order-from-date", {
                                    values: {
                                        date: new Date(order.insertTime).toLocaleDateString(),
                                    },
                                })}
                            </h3>
                            <div class="infotext">
                                <!--<div class="date"></div>-->
                                <!--<div class="ordernum">-->
                                {$_("my-orders.order-number-short")}:
                                {order.sequence}
                                <!--</div>-->
                            </div>
                        </div>
                        <div class="price">
                            {$formatPriceCurrency(order.sum.totalGross)}
                        </div>
                    </section>

                    <section>
                        <div class="header">
                            <h3>{$_("my-orders.payment-info")}</h3>
                        </div>
                        <div class="text">
                            {#if order.payment.type == "paypal"}
                                Paypal
                            {:else if order.payment.type == "invoice"}
                                $_("my-orders.invoice")
                            {/if}
                        </div>
                    </section>

                    <section style="border-bottom:0;">
                        <div class="header">
                            <h3>{$_("my-orders.contact")}</h3>
                        </div>

                        <div class="innersection">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="description">
                                        {$_("my-orders.email")}
                                    </div>
                                    {order.contact?.email || ""}
                                </div>
                                <div class="col-md-6"></div>
                            </div>
                        </div>

                        <div class="innersection">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="description">
                                        {$_("my-orders.phone")}
                                    </div>
                                    {order.contact?.phone || ""}
                                </div>
                                <div class="col-md-6"></div>
                            </div>
                        </div>
                    </section>

                    <section style="border-bottom:0;">
                        <div class="header">
                            <h3>Lieferadresse</h3>
                        </div>
                        <div class="innersection">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="description">
                                        {$_("my-orders.firstname")}
                                    </div>
                                    {order.deliveryAddress?.firstname || ""}
                                </div>
                                <div class="col-md-6">
                                    <div class="description">
                                        {$_("my-orders.lastname")}
                                    </div>
                                    {order.deliveryAddress?.lastname || ""}
                                </div>
                            </div>
                        </div>

                        <div class="innersection">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="description">
                                        {$_("my-orders.street-and-house-number")}
                                    </div>
                                    {order.deliveryAddress?.street || ""}
                                    {order.deliveryAddress?.houseNumber || ""}
                                </div>
                                <div class="col-md-6"></div>
                            </div>
                        </div>

                        <div class="innersection">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="description">
                                        {$_("my-orders.postcode")}
                                    </div>
                                    {order.deliveryAddress?.postcode || ""}
                                </div>
                                <div class="col-md-6">
                                    <div class="description">
                                        {$_("my-orders.city")}
                                    </div>
                                    {order.deliveryAddress?.city || ""}
                                </div>
                            </div>
                        </div>

                        <div class="innersection">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="description">
                                        {$_("my-orders.country")}
                                    </div>
                                    {langField(order.deliveryCountry?.name, "")}
                                </div>
                                <div class="col-md-6"></div>
                            </div>
                        </div>
                    </section>

                    <section style="border-bottom:0;">
                        <div class="header">
                            <h3>Rechnungsadresse</h3>
                        </div>
                        <div class="innersection">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="description">
                                        {$_("my-orders.firstname")}
                                    </div>
                                    {order.billingAddress?.firstname || ""}
                                </div>
                                <div class="col-md-6">
                                    <div class="description">
                                        {$_("my-orders.lastname")}
                                    </div>
                                    {order.billingAddress?.lastname || ""}
                                </div>
                            </div>
                        </div>

                        <div class="innersection">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="description">
                                        {$_("my-orders.street-and-house-number")}
                                    </div>
                                    {order.billingAddress?.street || ""}
                                    {order.billingAddress?.houseNumber || ""}
                                </div>
                                <div class="col-md-6"></div>
                            </div>
                        </div>

                        <div class="innersection">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="description">
                                        {$_("my-orders.postcode")}
                                    </div>
                                    {order.billingAddress?.postcode || ""}
                                </div>
                                <div class="col-md-6">
                                    <div class="description">
                                        {$_("my-orders.city")}
                                    </div>
                                    {order.billingAddress?.city || ""}
                                </div>
                            </div>
                        </div>

                        <div class="innersection">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="description">
                                        {$_("my-orders.country")}
                                    </div>
                                    {order.billingAddress?.countryCode || ""}
                                </div>
                                <div class="col-md-6"></div>
                            </div>
                        </div>
                    </section>

                    <section style="border-bottom:0; padding-bottom:0;">
                        <div class="header">
                            <h3>{$_("my-orders.ordered-items")}</h3>
                        </div>

                        <div class="products">
                            {#each order.cart || [] as item}
                                <div class="product">
                                    <div class="image">
                                        <img
                                            src="{item.product?.images?.length &&
                                                (item.product?.images[0].file?.src || '/media/kein-bild.jpg')}"
                                            alt=""
                                        />
                                    </div>
                                    <div class="text">
                                        <div class="headline">
                                            <h3>
                                                {langField(item.product?.name, "")}
                                            </h3>
                                            <div class="artnum">
                                                {$_("my-orders.item-number-short")}:
                                                {item.product?.code}
                                            </div>
                                        </div>
                                        {#if item.user_inputs && Object.keys(item.user_inputs).length}
                                            <div class="variant">
                                                {#if item.user_inputs?.engraving_line_1}
                                                    <b>{$_("my-orders.engraving-line-1")}:</b>
                                                    {item.user_inputs.engraving_line_1}<br />
                                                {/if}
                                                {#if item.user_inputs?.engraving_line_2}
                                                    <b>{$_("my-orders.engraving-line-2")}:</b>
                                                    {item.user_inputs.engraving_line_2}<br />
                                                {/if}
                                                {#if item.user_inputs?.engraving_line_3}
                                                    <b>{$_("my-orders.engraving-line-3")}:</b>
                                                    {item.user_inputs.engraving_line_3}<br />
                                                {/if}
                                                {#if item.user_inputs?.key_number}
                                                    <b>{$_("my-orders.key-number")}:</b>
                                                    {#if item.user_inputs.key_number == -1}
                                                        {$_("my-orders.whatever")}
                                                    {:else}
                                                        {item.user_inputs.key_number}
                                                    {/if}
                                                    <br />
                                                {/if}
                                            </div>
                                        {/if}
                                        <div class="bottom">
                                            <div class="count">
                                                {item.quantity}
                                                {$_("my-orders.pieces")}
                                            </div>
                                            <div class="price">
                                                {$formatPriceCurrency(item.price.unit)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            {/each}
                        </div>
                        {#if order.sum?.minQtyGross}
                            <div class="shipping_info">
                                <div class="infotext">
                                    <!--Mindermengenzuschlag-->{$_("my-orders.shipping-costs")}
                                </div>
                                <div class="price">
                                    {$formatPriceCurrency(order.sum?.minQtyGross)}
                                </div>
                            </div>
                        {/if}
                        {#if order.sum?.packagingGross}
                            <div class="shipping_info">
                                <div class="infotext">
                                    {$_("my-orders.packaging-costs")}
                                </div>
                                <div class="price">
                                    {$formatPriceCurrency(order.sum?.packagingGross)}
                                </div>
                            </div>
                        {/if}
                        {#if order.sum?.shippingGross}
                            <div class="shipping_info">
                                <div class="infotext">
                                    {$_("my-orders.shipping-costs")}
                                </div>
                                <div class="price">
                                    {$formatPriceCurrency(order.sum?.shippingGross)}
                                </div>
                            </div>
                        {/if}

                        <div class="endprice">
                            <div class="infotext">
                                {$_("my-orders.total-costs")}
                            </div>
                            <div class="price">
                                {$formatPriceCurrency(order.sum?.totalGross)}
                            </div>
                            <div class="vat">
                                {$_("my-orders.vat-included")}:
                                {$formatPriceCurrency(order.sum?.totalVAT)}
                            </div>
                        </div>
                    </section>
                </div>
            {:else}<b>{$_("my-orders.order-not-found")}</b><br /><br />{/if}
        {/await}

        <button
            on:click="{() => {
                history.back()
            }}"
            style="margin-top:60px;"
            class="btn btn-secondary">&laquo; {$_("my-orders.back-to-orders")}</button
        >
    </div>
</section>

<style lang="less">
    @import "../../css/variables.less";
    .order_details {
        section {
            border-bottom: dotted 1px #ccc;
            padding: 40px 0px;
            .header {
                margin-bottom: 30px;
                h3 {
                    margin: 0px;
                }
                .infotext {
                    .flex();
                    font-size: 14px;
                    /*.ordernum {
                        margin-left: 40px;
                    }*/
                }
            }
            .price {
                color: var(--primary);
                font-size: 1.8rem;
            }
            .innersection {
                font-weight: 800;
                border-bottom: dotted 1px #ccc;
            }
            .description {
                font-size: 14px;
                font-weight: 400;
            }
        }
        .products {
            .product {
                padding: 40px 0px;
                border-bottom: dotted 1px #ccc;
                .flex();
                flex-wrap: wrap;
                @media (max-width: 690px) {
                    flex-direction: column;
                }
                .image {
                    background: var(--surface);
                    width: 40%;
                    height: 20vw;
                    @media (max-width: 690px) {
                        width: 100%;
                        height: 40vw;
                    }
                    .flex();
                    align-items: center;
                    justify-content: center;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }
                .text {
                    padding-left: 30px;
                    width: 60%;
                    .flex();
                    flex-direction: column;
                    justify-content: space-between;
                    @media (max-width: 690px) {
                        width: 100%;
                    }
                    .artnum {
                        font-size: 14px;
                    }
                    .headline {
                        margin-bottom: 30px;
                    }
                    .bottom {
                        flex-grow: 1;
                        .flex();
                        justify-content: space-between;
                        align-items: flex-end;
                    }
                }
            }
        }
        .shipping_info {
            padding: 30px 0px;
            border-bottom: dotted 3px #ccc;
            .infotext {
                justify-content: flex-end;
                text-align: right;
            }
            text-align: right;
        }
        .endprice {
            padding: 30px 0px;
            .infotext {
                justify-content: flex-end;
                text-align: right;
            }
            text-align: right;
            .price {
                font-size: 2.5rem;
                font-weight: 800;
            }
        }
    }
</style>
